export default __webpack_public_path__ + "static/media/confused.739d88e3.svg";